import { render } from "./respuesta.vue?vue&type=template&id=0990170e&scoped=true"
import script from "./respuesta.vue?vue&type=script&lang=js"
export * from "./respuesta.vue?vue&type=script&lang=js"

import "./respuesta.vue?vue&type=style&index=0&id=0990170e&scoped=true&lang=css"
import "./respuesta.vue?vue&type=style&index=1&id=0990170e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0990170e"]])

export default __exports__